import type { QueryClient } from "@tanstack/react-query";

/** Poll only mounted access-related queries, never hidden tabs. */
export function configureAccessRefresh(client: QueryClient) {
  for (const key of [
    "members",
    "member-access",
    "clients",
    "subscription",
    "revoked-members",
  ]) {
    client.setQueryDefaults([key], {
      refetchInterval: 30_000,
      refetchIntervalInBackground: false,
      refetchOnWindowFocus: "always",
      refetchOnReconnect: "always",
    });
  }
}
